<template>
  <span class="spvg-ico-arrow-in-down-rectangle">
    <svg viewBox="0 0 24 24" :style="`width:${width}px;height:${width}px;fill:none;`" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.44 8.8999C20.04 9.2099 21.51 11.0599 21.51 15.1099V15.2399C21.51 19.7099 19.72 21.4999 15.25 21.4999H8.73998C4.26998 21.4999 2.47998 19.7099 2.47998 15.2399V15.1099C2.47998 11.0899 3.92998 9.2399 7.46998 8.9099" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 2V14.88" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.3499 12.6499L11.9999 15.9999L8.6499 12.6499" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
